import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PROPERTY_ID = "69d79ffb9f2caf1c32915a1c";
const WIDGET_ID = "default";

// Routes where the live chat should be hidden (admin & sensitive screens)
const HIDDEN_ROUTES = ["/admin", "/dashboard", "/transactions"];

/**
 * Tawk.to live chat widget loader.
 * - Loads the embed script exactly once (idempotent across route changes).
 * - Hides/shows the widget on certain routes via the Tawk_API.
 */
export default function TawkChat() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.__tawkLoaded) return;
    window.__tawkLoaded = true;

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const s = document.createElement("script");
    s.async = true;
    s.src = `https://embed.tawk.to/${PROPERTY_ID}/${WIDGET_ID}`;
    s.charset = "UTF-8";
    s.setAttribute("crossorigin", "*");
    document.head.appendChild(s);
  }, []);

  useEffect(() => {
    const api = typeof window !== "undefined" ? window.Tawk_API : null;
    if (!api) return;
    const shouldHide = HIDDEN_ROUTES.some((p) => pathname.startsWith(p));
    const apply = () => {
      try {
        if (shouldHide) api.hideWidget && api.hideWidget();
        else api.showWidget && api.showWidget();
      } catch {
        // widget not yet ready — retry on next route change
      }
    };
    // The script loads async; queue a few attempts in case the API isn't ready yet
    apply();
    const t1 = setTimeout(apply, 800);
    const t2 = setTimeout(apply, 2000);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [pathname]);

  return null;
}
